import React from "react";
import { withTranslation } from "react-i18next";
import about1 from "../../assets/about1.jpg";
import Page from "../../components/Page";
import "./styles.css";

const index = ({ t }) => {
  return (
    <Page className="landing-page">
      <div className="aboutus">
        <img src={about1} width="100%" height="300px" className="mainAbout"/>
        <h3 className="text-dark border-0 text-center mt-3">Our Vision</h3>
        <p className="text-center p">
          We see a world where looking for a job, or hiring an employee is an
          easy task. It's a place where Job Seekers are represented for who they
          are and not misunderstood by a resume. This place is a place where
          company culture and personalities, skills and talents are valued.
          Employers are able to save both time and money by learning about
          candidates and knowing if they are a right fit for the company before
          the interview takes place.
          <br />
          <br /> We see a world where connecting Job Seekers with Employers is
          an enjoyable experience.
        </p>
        <div className="mission">
          <div className="missionC">
            <h3 className="text-white border-0 mt-3">Our Mission</h3>
            <p className="text-white">
              Our mission is to provide a fresh approach & hassle-free solution
              that changes the way Job Seekers & Employers connect. We exist to
              create a positive experience for both sides of the hiring
              spectrum. From job seeking, to recruiting, to managing the hiring
              process, we are here to remove the barriers and open communication
              - creating real connections with real people. <br /> -All for
              free-
            </p>
          </div>
        </div>
        <h3 className="text-dark border-0 text-center mt-3">Our Why</h3>
        <p className="text-center p">
          The key to impactful technology solutions are innovative, pragmatic
          ideas developed by compassionate people who are deeply invested in
          your needs. We look at every problem from every direction and try to
          figure out the right way to solve it to best suit your needs. We
          believe in honoring our commitments and striving to do the right thing
          every time, and that means working our best to make sure your
          experience with the hiring process is the best that it can be.
          <br />
          <br /> With that, we recognized something was missing. If everything
          is going digital, why are traditional resumes still used as the most
          important hiring artifact when it does nothing to solve the biggest
          problem in the hiring process, the disconnect between Job Seekers &
          Employers? We are here to fix that.
        </p>
        <div className="story mb-3">
          <div className="storyC">
            <h3 className="text-dark border-0">Our Story</h3>
            <p className="text-black">
              “faces2hire.com was built from the belief that no Employer should
              have to pay to post a job, or hire employees, nor should job
              seekers be required to pay a fee to find hiring employers or land
              their dream job.” - Michael Frangedis, Founder
            </p>
          </div>
        </div>
        <p className="text-center p">
          While building multiple businesses, Michael saw that Job Seekers’
          resumes were not representing them for who they actually were, and as
          an Employer, it was becoming increasingly difficult to find good
          Employees and manage the hiring process. So, he decided to do
          something about it and faces2hire was born. <br />
          <br />
          Since inception in 2013, we have kept to our roots in remaining a free
          recruiting tool for both Job Seekers and Employers. We also provide a
          free all in one Applicant Tracking System (ATS) geared towards small
          businesses, assisting them in finding, tracking and managing talent
          during their hiring process.
        </p>
      </div>
    </Page>
  );
};

export default withTranslation()(index);
